import React from 'react';
import { Container } from 'react-bootstrap';
import roundImg from "../assets/round_shape.png";
import princessImg from "../assets/princess_shape.png";
import cushanImg from "../assets/cushan_shape.png";
import emeraldImg from "../assets/emerald_shape.png";
import ovalImg from "../assets/oval_shape.png";
import pearImg from "../assets/pear_shape.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useTranslation } from 'react-i18next';

const ShopByShape = () => {
  const { t } = useTranslation();

  const shapes = [
    { name: t('shopByShape.shapes.round.name'), desc: t('shopByShape.shapes.round.desc'), img: roundImg },
    { name: t('shopByShape.shapes.princess.name'), desc: t('shopByShape.shapes.princess.desc'), img: princessImg },
    { name: t('shopByShape.shapes.cushion.name'), desc: t('shopByShape.shapes.cushion.desc'), img: cushanImg },
    { name: t('shopByShape.shapes.emerald.name'), desc: t('shopByShape.shapes.emerald.desc'), img: emeraldImg },
    { name: t('shopByShape.shapes.oval.name'), desc: t('shopByShape.shapes.oval.desc'), img: ovalImg },
    { name: t('shopByShape.shapes.pear.name'), desc: t('shopByShape.shapes.pear.desc'), img: pearImg }
  ];

  return (
    <section className="py-5" style={{ backgroundColor: 'var(--color-surface)' }} id="products">
      <Container className="py-5 text-center" data-aos="fade-up">
        <h6 className="text-uppercase mb-3" style={{ color: 'var(--color-accent)', letterSpacing: '2px', fontWeight: 'bold' }}>
          {t('shopByShape.subtitle')}
        </h6>
        <h2 className="display-5 fw-bold text-dark mb-3" style={{ fontFamily: 'var(--font-serif)' }}>
          {t('shopByShape.title')}
        </h2>
        <p className="text-dark opacity-75 mx-auto" style={{ maxWidth: '600px' }}>
          {t('shopByShape.description')}
        </p>
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          spaceBetween={20}
          navigation
          autoplay={{ delay: 2500 }}
          loop={true}
          breakpoints={{
            640: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 3, spaceBetween: 30 },
            1024: { slidesPerView: 4, spaceBetween: 30 },
          }}
          className="px-4"
        >
          {shapes.map((shape, index) => (
            <SwiperSlide key={index}>
              <div className="shape-card mt-4">
                <div className="shape-icon-box">
                  <img src={shape.img} alt={shape.name} className="img-fluid" />
                  <div className="shape-pop-badge">
                    <span className="small">{shape.desc}</span>
                  </div>
                </div>
                <h6 className="shape-name mt-4 sunflower">{shape.name}</h6>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default ShopByShape;
